import { VHeaders } from '@/models/pagedlistmodel';

export function getCallTypeHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('callTypes.callTypeGirdHeaders.name') as string,
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'callTypes.callTypeGirdHeaders.description'
      ) as string,
      align: 'left',
      value: 'description',
    },
    {
      text: vm.$parent.$t('callTypes.callTypeGirdHeaders.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
